import { createContext, ReactNode, useContext } from 'react';

import { LastMonthReportService } from '@shared/types/mobx/services/accountReports/lastMonthReports';

const LastMonthReportContext = createContext<LastMonthReportService | null>(null);

interface Props {
  viewModel: LastMonthReportService;
  children: ReactNode;
}

const LastMonthReportProvider: React.FC<Props> = ({ viewModel, children }) => (
  <LastMonthReportContext.Provider value={viewModel}>{children}</LastMonthReportContext.Provider>
);

const useLastMonthReportContext = () => {
  const context = useContext(LastMonthReportContext);
  if (context === undefined) {
    throw new Error('LastMonthReportContext was used outside of its context');
  }

  if (context === null) {
    throw new Error('useLastMonthReportContext: context is null');
  }

  return context;
};

export { LastMonthReportProvider, useLastMonthReportContext };
